export enum WorkLocationType {
  UserResidence = "USER_RESIDENCE",
  ClientLocation = "CLIENT_LOCATION",
  OfficeLocation = "OFFICE_LOCATION"
}